import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-044ade42"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container mx-auto px-4 py-8" }
const _hoisted_2 = { class: "max-w-7xl mx-auto" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-8" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-4xl font-bold text-slate-100 mb-4" }, "🎨 Mermaid Diagram Converter"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-lg text-slate-400" }, "Convert your Mermaid diagrams to PNG, JPG, SVG, or PDF")
], -1))
const _hoisted_4 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-8" }
const _hoisted_5 = { class: "bg-slate-800 border border-slate-700 rounded-lg shadow-lg p-6" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-semibold text-slate-100 mb-4" }, "📝 Mermaid Markdown Input", -1))
const _hoisted_7 = { class: "flex gap-3 mt-4" }
const _hoisted_8 = { class: "bg-slate-800 border border-slate-700 rounded-lg shadow-lg p-6" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-semibold text-slate-100 mb-4" }, "👁️ Preview & Export", -1))
const _hoisted_10 = { class: "border border-slate-700 rounded-lg p-5 min-h-80 bg-slate-900 flex items-center justify-center overflow-auto" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "grid grid-cols-2 gap-3 mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.mermaidInput) = $event)),
            class: "w-full h-80 p-4 bg-slate-900 border border-slate-700 rounded-lg font-mono text-sm resize-vertical focus:border-blue-500 focus:outline-none transition-colors text-slate-200",
            placeholder: "Enter your Mermaid diagram here...\n\nExample:\ngraph TD\n    A[Start] --> B{Decision}\n    B -->|Yes| C[Process 1]\n    B -->|No| D[Process 2]\n    C --> E[End]\n    D --> E"
          }, null, 512), [
            [_vModelText, _ctx.mermaidInput]
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.renderDiagram && _ctx.renderDiagram(...args))),
              class: "flex-1 bg-gradient-to-r from-blue-500 to-purple-600 text-white px-6 py-3 rounded-lg font-semibold hover:from-blue-600 hover:to-purple-700 transform hover:-translate-y-1 transition-all duration-200 shadow-lg hover:shadow-xl"
            }, " 🔄 Render Diagram "),
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clearAll && _ctx.clearAll(...args))),
              class: "flex-1 bg-slate-700 text-slate-200 px-6 py-3 rounded-lg font-semibold hover:bg-slate-600 transition-colors"
            }, " 🗑️ Clear ")
          ]),
          (_ctx.statusMessage)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass([
              'mt-4 p-3 rounded-lg text-center text-sm font-medium',
              _ctx.statusType === 'success' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
            ])
              }, _toDisplayString(_ctx.statusMessage), 3))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", {
              innerHTML: _ctx.previewContent,
              class: "max-w-full"
            }, null, 8, _hoisted_11)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.exportAs('png'))),
              class: "bg-slate-800 border border-blue-500 text-blue-400 px-4 py-3 rounded-lg font-semibold hover:bg-blue-500 hover:text-white transform hover:-translate-y-1 transition-all duration-200"
            }, " 📥 Download PNG "),
            _createElementVNode("button", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.exportAs('jpg'))),
              class: "bg-slate-800 border border-blue-500 text-blue-400 px-4 py-3 rounded-lg font-semibold hover:bg-blue-500 hover:text-white transform hover:-translate-y-1 transition-all duration-200"
            }, " 📥 Download JPG "),
            _createElementVNode("button", {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.exportAs('svg'))),
              class: "bg-slate-800 border border-blue-500 text-blue-400 px-4 py-3 rounded-lg font-semibold hover:bg-blue-500 hover:text-white transform hover:-translate-y-1 transition-all duration-200"
            }, " 📥 Download SVG ")
          ])
        ])
      ])
    ])
  ]))
}